import { CircularProgress } from "@mui/material";
import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import useProfile from "../../hooks/useProfile";

const AdminRoute = ({ children }) => {
  // const { user, loading } = useContext(AuthContext);
  const [userData, isLoading, isError, error] = useProfile();

  //   const [isAdmin, isAdminLoading] = useAdmin(user?.email);
  const location = useLocation();

  if (isLoading) {
    return <CircularProgress />;
  }

  if (
    userData.ugleve_name === "Admin" ||
    userData.ugleve_name === "Developer"
  ) {
    return children;
  }

  return <Navigate to="/" state={{ from: location }} replace></Navigate>;
};

export default AdminRoute;
